import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dList from "../Data.List/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMonoid from "../Data.Monoid/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dSemigroup from "../Data.Semigroup/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dString$dCodePoints from "../Data.String.CodePoints/index.js";
import * as Data$dString$dCommon from "../Data.String.Common/index.js";
import * as Data$dTraversable from "../Data.Traversable/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
import * as Data$dValidation$dSemigroup from "../Data.Validation.Semigroup/index.js";
import * as Data$dVault from "../Data.Vault/index.js";
import * as Effect$dClass from "../Effect.Class/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Foreign$dObject from "../Foreign.Object/index.js";
import * as Record from "../Record/index.js";
import * as Record$dBuilder from "../Record.Builder/index.js";
import * as Record$dUnsafe from "../Record.Unsafe/index.js";
import * as Restaumatic$dCommon$dTranslations$dKeys from "../Restaumatic.Common.Translations.Keys/index.js";
import * as Restaumatic$dForm$dDynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic$dForm$dErrors from "../Restaumatic.Form.Errors/index.js";
import * as Restaumatic$dForm$dFinal from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic$dForm$dResult from "../Restaumatic.Form.Result/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dI18n$dTranslationKeys from "../Restaumatic.I18n.TranslationKeys/index.js";
import * as Specular$dExtra$dAsync from "../Specular.Extra.Async/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dHost from "../Specular.FRP.Host/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dFormField from "../Specular.FormField/index.js";
import * as Specular$dInternal$dIncremental from "../Specular.Internal.Incremental/index.js";
import * as Specular$dInternal$dIncremental$dNode from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
import * as Specular$dProfiling from "../Specular.Profiling/index.js";
import * as Specular$dRef from "../Specular.Ref/index.js";
import * as Specular$dSelect from "../Specular.Select/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
const $ContextInitializer = (_1, _2) => ({tag: "ContextInitializer", _1, _2});
const $InitialValueInitializer = (_1, _2) => ({tag: "InitialValueInitializer", _1, _2});
const $MetadataInitializer = (_1, _2) => ({tag: "MetadataInitializer", _1, _2});
const $NoInitialValue = () => ({tag: "NoInitialValue"});
const $NoInitializer = () => ({tag: "NoInitializer"});
const $SomeInitialValue = _1 => ({tag: "SomeInitialValue", _1});
const $TypedValue = (tag, _1) => ({tag, _1});
const $WithId = _1 => ({tag: "WithId", _1});
const write1 = r => x => r._2(_old => x);
const identity = x => x;
const ordMaybe = /* #__PURE__ */ Data$dMaybe.ordMaybe(/* #__PURE__ */ Data$dOrd.ordArray(Data$dOrd.ordString));
const measure = /* #__PURE__ */ Specular$dProfiling.measure(Effect$dClass.monadEffectEffect);
const traverse = /* #__PURE__ */ (() => Data$dValidation$dSemigroup.traversableV.traverse(Specular$dFRP$dBase.applicativeDynamic))();
const identity1 = x => x;
const lastValidIsSymbol = {reflectSymbol: () => "lastValid"};
const UndefinedIsSymbol = {reflectSymbol: () => "Undefined"};
const editValueIsSymbol = {reflectSymbol: () => "editValue"};
const errorIsSymbol = {reflectSymbol: () => "error"};
const showMaybe = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const InvalidIsSymbol = {reflectSymbol: () => "Invalid"};
const valueIsSymbol = {reflectSymbol: () => "value"};
const ValidIsSymbol = {reflectSymbol: () => "Valid"};
const sequence = /* #__PURE__ */ (() => Data$dTraversable.traversableArray.traverse(Specular$dFRP$dBase.applicativeDynamic)(Data$dTraversable.identity))();
const length = /* #__PURE__ */ Data$dFoldable.foldlArray(c => v => 1 + c | 0)(0);
const encodeWithOptionsOther = {encodeWithOptions: v => Restaumatic$dForm$dErrors.encodeFormErrors.encode};
const encodeWithOptionsOther1 = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const sequence1 = /* #__PURE__ */ (() => Data$dTraversable.traversableMaybe.sequence(Specular$dFRP$dBase.applicativeDynamic))();
const encode = x => Foreign$dObject._mapWithKey(x, v => Foreign$dGeneric$dClass.identity);
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dList.toUnfoldable(Data$dUnfoldable.unfoldableArray);
  return x => $0(Data$dMap$dInternal.keys(x));
})();
const WithOptions = x => x;
const WithId = value0 => $WithId(value0);
const Undefined = value0 => $TypedValue("Undefined", value0);
const Invalid = value0 => $TypedValue("Invalid", value0);
const Valid = value0 => $TypedValue("Valid", value0);
const SomeInitialValue = value0 => $SomeInitialValue(value0);
const RefWithOptions = x => x;
const NoInitializer = /* #__PURE__ */ $NoInitializer();
const NoInitialValue = /* #__PURE__ */ $NoInitialValue();
const MetadataInitializer = value0 => value1 => $MetadataInitializer(value0, value1);
const Metadata = x => x;
const MappedField = x => x;
const InitialValueInitializer = value0 => value1 => $InitialValueInitializer(value0, value1);
const FormDefM = x => x;
const EffectInitializer = x => x;
const ContextInitializer = value0 => value1 => $ContextInitializer(value0, value1);
const Attribute = x => x;
const mergeRef = dictTypeEquals => {
  const to = dictTypeEquals.proof(a => a);
  return {
    merge: x => ref => {
      const $0 = to(x);
      return ref._2(_old => $0);
    }
  };
};
const maybeGetInitializer$pTrue = dictIsSymbol => () => ({"maybeGetInitializer'": v => label => Record.get(dictIsSymbol)()(label)});
const maybeGetInitializer$pFalse = {"maybeGetInitializer'": v => v1 => v2 => NoInitializer};
const maybeGetInitialValue$pTrue = dictIsSymbol => () => (
  {"maybeGetInitialValue'": v => label => x => $SomeInitialValue(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(label))(x))}
);
const maybeGetInitialValue$pFals = {"maybeGetInitialValue'": v => v1 => v2 => NoInitialValue};
const isRefLikeRef = {
  readRefLike: x => Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(x._1),
  writeRefLike: ref => v => {
    if (v.tag === "Valid") {
      const $0 = v._1.value;
      return ref._2(_old => $0);
    }
    return () => {};
  },
  touchRefLike: v => () => {}
};
const hasLabelRef = {
  getLabel: v => {
    const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.Nothing);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  }
};
const hasLabelFormField = {
  getLabel: v => {
    const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.Nothing);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  }
};
const hasFieldIdWithId = {getFieldId: v => v._1.id};
const hasFieldIdString = {getFieldId: identity};
const hasFieldIdRef = () => ({getFieldId: v => ""});
const hasFieldIdFunctionEffect = () => ({getFieldId: v => ""});
const hasFieldIdFormField = () => ({getFieldId: v => ""});
const hasFieldIdEffect = () => ({getFieldId: v => ""});
const hasFieldIdChoiceRef = () => ({getFieldId: v => ""});
const hasErrorsRef = {
  displayedErrors: v => {
    const n = Specular$dInternal$dIncremental.constant([]);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  }
};
const hasErrorsChoiceRef = {
  displayedErrors: v => {
    const n = Specular$dInternal$dIncremental.constant([]);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  }
};
const hasContextRefContext = {getContext: Specular$dRef.value};
const hasContextContext = /* #__PURE__ */ (() => ({getContext: Specular$dFRP$dBase.applicativeDynamic.pure}))();
const addMetadataRecordNil = {addMetadataRecord: v => v1 => r => r};
const addMetadataMetadataRecord = () => () => ({addMetadata: v => i1 => ({label: v.label, options: v.options, ...i1})});
const addMetadataMetadataNoInit = {addMetadata: v => v1 => ({label: v.label, options: v.options})};
const addMetadataFinalStringRec = () => () => ({addMetadata: label => i1 => ({label: label, ...i1})});
const addMetadataFinalStringNoI = {addMetadata: label => v => ({label})};
const addMetadataEffectEffect = {addMetadata: v => i => i};
const addMetadataDynamicDynamic = {addMetadata: v => i => i};
const addContextRef = {addContext: v => v1 => () => {}};
const addContextFormField = {addContext: v => v1 => () => {}};
const addContextEffect = {addContext: v => v1 => () => {}};
const addContextDynamic = {addContext: v => v1 => () => {}};
const writeRefLike = dict => dict.writeRefLike;
const writeRef = () => write1;
const isTextFieldFormFieldStrin = {
  textInput: f => (
    {
      onChange: value => f.editRef._2(_old => value),
      onTouch: f.focusOutCallback(),
      displayedValue: f.editRef._1,
      placeholder: (() => {
        const n = Specular$dInternal$dIncremental.constant("");
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })()
    }
  )
};
const isTextFieldRefString = {
  textInput: f => (
    {
      onChange: value => f._2(_old => value),
      onTouch: () => {},
      displayedValue: f._1,
      placeholder: (() => {
        const n = Specular$dInternal$dIncremental.constant("");
        Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
        return n;
      })()
    }
  )
};
const withMetadata = MetadataInitializer;
const withInitialValue = InitialValueInitializer;
const withId = id => field => $WithId({id, field});
const withFinal_ = dictMonadReplace => {
  const withDynamic_ = Specular$dFRP$dReplaceable.withDynamic_(dictMonadReplace);
  return dictMonadFRP => {
    const withDynamic_1 = withDynamic_(dictMonadFRP);
    const traverse_1 = Data$dFoldable.traverse_(dictMonadFRP.MonadCleanup1().Monad0().Applicative0())(Data$dFoldable.foldableMaybe);
    return f => block => withDynamic_1(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toMaybeLax)(f))(traverse_1(block));
  };
};
const withEffect = EffectInitializer;
const withContext = ContextInitializer;
const validateWhenValueJust = validation => paramF => value => Restaumatic$dForm$dDynamicResult.andThen(paramF)(v => {
  if (v.tag === "Nothing") { return Restaumatic$dForm$dDynamicResult.applicativeDynamicResult.pure([]); }
  if (v.tag === "Just") { return validation(Restaumatic$dForm$dDynamicResult.applicativeDynamicResult.pure(v._1))(value); }
  $runtime.fail();
});
const validateWhenJust = validation => paramF => value => Restaumatic$dForm$dDynamicResult.andThen(paramF)(v => {
  if (v.tag === "Nothing") { return Restaumatic$dForm$dDynamicResult.applicativeDynamicResult.pure([]); }
  if (v.tag === "Just") { return validation(Restaumatic$dForm$dDynamicResult.applicativeDynamicResult.pure(v._1))(value); }
  $runtime.fail();
});
const validateTrue = /* #__PURE__ */ (() => Restaumatic$dForm$dDynamicResult.functorDynamicResult.map(v => {
  const $0 = !v;
  const $1 = [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})];
  if (!$0) { return []; }
  if ($0) { return $1; }
  $runtime.fail();
}))();
const validateJust = validation => value => Restaumatic$dForm$dDynamicResult.andThen(value)(v => {
  if (v.tag === "Just") { return validation(Restaumatic$dForm$dDynamicResult.applicativeDynamicResult.pure(v._1)); }
  if (v.tag === "Nothing") { return Restaumatic$dForm$dDynamicResult.applicativeDynamicResult.pure([]); }
  $runtime.fail();
});
const validateJustIf = v => v1 => v2 => {
  if (!v) { return Restaumatic$dForm$dDynamicResult.applicativeDynamicResult.pure([]); }
  if (v) { return validateJust(v1)(v2); }
  $runtime.fail();
};
const unFinalWithDefault = def => {
  const $0 = Specular$dFRP$dBase.functorDynamic.map(v2 => {
    if (v2.tag === "Nothing") { return def; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  });
  return x => $0(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toMaybeLax)(x));
};
const unFinalFromContextDef = d => key => ctxRef => Specular$dFRP$dBase.bindDynamic.bind(ctxRef._1)(context1 => {
  const $0 = (() => {
    const n = Specular$dInternal$dIncremental.constant(d);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })();
  const $1 = unFinalWithDefault(d);
  const $2 = Data$dMap$dInternal.lookup(Data$dOrd.ordInt)(key)(context1);
  if ($2.tag === "Just") { return $1($2._1); }
  return $0;
});
const touchRefLike = dict => dict.touchRefLike;
const toRecord = dict => dict.toRecord;
const toArray = dict => dict.toArray;
const textInput = dict => dict.textInput;
const isTextFieldWithId = dictIsTextField => ({textInput: v => dictIsTextField.textInput(v._1.field)});
const tagErrors = fieldName => label => errors => {
  const v = Data$dMap$dInternal.lookup(ordMaybe)(Data$dMaybe.Nothing)(errors);
  return (() => {
    if (v.tag === "Just") {
      return Data$dMap$dInternal.insertWith(ordMaybe)(Data$dSemigroup.concatArray)(Data$dMaybe.$Maybe("Just", fieldName))(Data$dFunctor.arrayMap(error => (
        {...error, fieldName: Data$dMaybe.$Maybe("Just", fieldName), fieldLabel: label}
      ))(v._1));
    }
    if (v.tag === "Nothing") { return identity; }
    $runtime.fail();
  })()(Data$dMap$dInternal.delete(ordMaybe)(Data$dMaybe.Nothing)(errors));
};
const singleOption = label => key => Specular$dSelect.$Option("SingleOption", {label, key, disabled: false});
const withNothing = emptyLabel => opts => Data$dSemigroup.concatArray([Specular$dSelect.$Option("SingleOption", {label: emptyLabel, key: Data$dMaybe.Nothing, disabled: false})])(Data$dFunctor.arrayMap(Specular$dSelect.functorOption.map(Data$dMaybe.Just))(opts));
const withOptions = field => label => ({field, toOption: a => Specular$dSelect.$Option("SingleOption", {label: label(a), key: a, disabled: false})});
const shorterThan = /* #__PURE__ */ (() => {
  const map = Restaumatic$dForm$dDynamicResult.applyDynamicResult.Functor0().map;
  return a => b => Restaumatic$dForm$dDynamicResult.applyDynamicResult.apply(map(threshold => value => {
    const $0 = [
      Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.shorterThan),
        {threshold: Data$dShow.showIntImpl(threshold)}
      )
    ];
    if (Data$dString$dCodePoints.toCodePointArray(value).length <= threshold) { return []; }
    return $0;
  })(a))(b);
})();
const selectWriteValue = dict => dict.selectWriteValue;
const selectTouch = dict => dict.selectTouch;
const selectReadValue = dict => dict.selectReadValue;
const selectGetOptions = dict => dict.selectGetOptions;
const selectInput = dictEq => dictIsSelectField => field => (
  {
    onChange: v => {
      if (v.tag === "Just") { return dictIsSelectField.selectWriteValue(field)(v._1); }
      if (v.tag === "Nothing") { return () => {}; }
      $runtime.fail();
    },
    displayedValue: Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(dictIsSelectField.selectReadValue(field)),
    displayedOptions: Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v => v1 => Data$dSemigroup.concatArray((() => {
      if (v1.tag === "Just") {
        if (Data$dArray.anyImpl(Specular$dSelect.containsKey(dictEq)(v1._1), v)) { return []; }
        return [Specular$dSelect.$Option("SingleOption", {key: Data$dMaybe.$Maybe("Just", v1._1), label: "", disabled: false})];
      }
      if (v1.tag === "Nothing") { return [Specular$dSelect.$Option("SingleOption", {key: Data$dMaybe.Nothing, label: "", disabled: false})]; }
      $runtime.fail();
    })())(Data$dFunctor.arrayMap(Specular$dSelect.functorOption.map(Data$dMaybe.Just))(v)))(dictIsSelectField.selectGetOptions(field)))(dictIsSelectField.selectReadValue(field)),
    onTouch: dictIsSelectField.selectTouch(field)
  }
);
const isSelectFieldWithId = dictIsSelectField => (
  {
    selectWriteValue: v => dictIsSelectField.selectWriteValue(v._1.field),
    selectReadValue: v => dictIsSelectField.selectReadValue(v._1.field),
    selectGetOptions: v => dictIsSelectField.selectGetOptions(v._1.field),
    selectTouch: v => dictIsSelectField.selectTouch(v._1.field)
  }
);
const requiredError = v => Restaumatic$dForm$dErrors.userVisibleErrors([
  Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})
]);
const readRefLike = dict => dict.readRefLike;
const isRefLikeFormField = {
  readRefLike: x => Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(x.editRef._1),
  writeRefLike: x => {
    const $0 = x.editRef;
    return v => {
      if (v.tag === "Valid") {
        const $1 = v._1.value;
        return $0._2(_old => $1);
      }
      return () => {};
    };
  },
  touchRefLike: field => field.focusOutCallback()
};
const isRefLikeWithId = dictIsRefLike => (
  {writeRefLike: v => dictIsRefLike.writeRefLike(v._1.field), readRefLike: v => dictIsRefLike.readRefLike(v._1.field), touchRefLike: v => dictIsRefLike.touchRefLike(v._1.field)}
);
const optionForEq = () => Unsafe$dCoerce.unsafeCoerce;
const nonEmpty = /* #__PURE__ */ (() => Restaumatic$dForm$dDynamicResult.functorDynamicResult.map(s => {
  const $0 = s === "";
  const $1 = [Restaumatic$dI18n._translate(Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.required), {})];
  if (!$0) { return []; }
  if ($0) { return $1; }
  $runtime.fail();
}))();
const monadFormDefM = Specular$dInternal$dRIO.monadRIO;
const monadEffectFormDefM = Specular$dInternal$dRIO.monadEffectRIO;
const monadCleanupFormDefM = Specular$dFRP$dHost.monadCleanupHost;
const mergeUnit = dictTypeEquals => ({merge: v => v1 => () => {}});
const mergeRecordNil = {mergeRecord: v => v1 => v2 => () => {}};
const mergeRecord = dict => dict.mergeRecord;
const merge_Record = dictAsRecord => () => dictMergeRecord => ({merge: d => f => dictMergeRecord.mergeRecord(Type$dProxy.Proxy)(dictAsRecord.toRecord(d))(f)});
const mergeInputRequired = dict => dict.mergeInputRequired;
const merge = dict => dict.merge;
const mergeRecordCons = dictIsSymbol => dictMergeRecord => dictMerge => () => () => () => () => (
  {
    mergeRecord: v => r => f => {
      const $0 = measure("merge " + dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(dictMerge.merge(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(r))(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(f)));
      return () => {
        $0();
        return dictMergeRecord.mergeRecord(Type$dProxy.Proxy)(r)(f)();
      };
    }
  }
);
const write = dictMerge => dictMonadEffect => field => value => dictMonadEffect.liftEffect(dictMerge.merge(value)(field));
const mergeChoiceRef = dictTypeEquals => {
  const to = dictTypeEquals.proof(a => a);
  return {
    merge: x => ref => {
      const $0 = to(x);
      return ref.currentChoice._2(_old => $0);
    }
  };
};
const mergeDelayed = dictMerge => (
  {
    merge: x => v => {
      const $0 = Specular$dFRP$dBase.readDynamic(Effect$dClass.monadEffectEffect)(v);
      return () => {
        const field = $0();
        return dictMerge.merge(x)(field)();
      };
    }
  }
);
const mergeT2T2 = dictMerge => dictMerge1 => (
  {
    merge: v => v1 => {
      const $0 = v._2;
      const $1 = v1._2;
      const $2 = dictMerge.merge(v._1)(v1._1);
      return () => {
        $2();
        return dictMerge1.merge($0)($1)();
      };
    }
  }
);
const maybeGetInitializer$p = dict => dict["maybeGetInitializer'"];
const maybeGetInitializer1 = () => dictMaybeGetInitializer$p => ({maybeGetInitializer: dictMaybeGetInitializer$p["maybeGetInitializer'"](Type$dProxy.Proxy)});
const maybeGetInitializer = dict => dict.maybeGetInitializer;
const maybeGetInitialValue$p = dict => dict["maybeGetInitialValue'"];
const maybeGetInitialValue1 = () => dictMaybeGetInitialValue$p => ({maybeGetInitialValue: dictMaybeGetInitialValue$p["maybeGetInitialValue'"](Type$dProxy.Proxy)});
const maybeGetInitialValue = dict => dict.maybeGetInitialValue;
const maybeContainerToArray = dictContainer => v => {
  if (v.tag === "Nothing") { return []; }
  if (v.tag === "Just") { return dictContainer.toArray(v._1); }
  $runtime.fail();
};
const mapVFinal = f => {
  const $0 = Specular$dFRP$dBase.functorDynamic.map(v2 => {
    if (v2.tag === "Left") { return Data$dEither.$Either("Left", v2._1); }
    if (v2.tag === "Right") { return f(v2._1); }
    $runtime.fail();
  });
  return x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.liftV)($0(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toVLax)(x)));
};
const mapMaybeFinalUserVisible = errorMessage => f => {
  const $0 = Specular$dFRP$dBase.functorDynamic.map(v2 => {
    if (v2.tag === "Left") { return Data$dEither.$Either("Left", v2._1); }
    if (v2.tag === "Right") {
      const v = f(v2._1);
      if (v.tag === "Nothing") { return Data$dEither.$Either("Left", Restaumatic$dForm$dErrors.userVisibleErrors([errorMessage])); }
      if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
      $runtime.fail();
    }
    $runtime.fail();
  });
  return x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.liftV)($0(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toVLax)(x)));
};
const mapMaybeFinalInternal = errorMessage => f => {
  const $0 = Specular$dFRP$dBase.functorDynamic.map(v2 => {
    if (v2.tag === "Left") { return Data$dEither.$Either("Left", v2._1); }
    if (v2.tag === "Right") {
      const v = f(v2._1);
      if (v.tag === "Nothing") {
        return Data$dEither.$Either(
          "Left",
          Data$dMap$dInternal.$$$Map(
            "Node",
            1,
            1,
            Data$dMaybe.Nothing,
            [{fieldName: Data$dMaybe.Nothing, fieldLabel: Data$dMaybe.Nothing, message: errorMessage, internal: true}],
            Data$dMap$dInternal.Leaf,
            Data$dMap$dInternal.Leaf
          )
        );
      }
      if (v.tag === "Just") { return Data$dEither.$Either("Right", v._1); }
      $runtime.fail();
    }
    $runtime.fail();
  });
  return x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.liftV)($0(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toVLax)(x)));
};
const mapMaybeFinal = /* #__PURE__ */ mapMaybeFinalInternal("Unknown error (mapMaybeFinal)");
const mapDynamicFinal = f => x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.liftV)(Specular$dFRP$dBase.bindDynamic.bind(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toVLax)(x))(traverse(f)));
const makeWithInitialValueInitializer = dict => dict.makeWithInitialValueInitializer;
const initializeInitialValueIni = dictMakeWithInitialValueInitializer => ({makeImpl: dictMakeWithInitialValueInitializer.makeWithInitialValueInitializer});
const makeRecordImpl = dict => dict.makeRecordImpl;
const initializeSomeInitialValu = dictAsRecord => () => dictInitializeRecord => (
  {
    makeImpl: p => opts => Specular$dInternal$dRIO.bindImpl(dictInitializeRecord.makeRecordImpl(p)(Type$dProxy.Proxy)(opts))(v => Specular$dInternal$dRIO.pureImpl({
      field: v.field({}),
      init: v1 => v.init(dictAsRecord.toRecord(v1._1))
    }))
  }
);
const makeImpl = dict => dict.makeImpl;
const makeWithDefaultInitializer = dictInitialize => defaultInitializer => p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => Specular$dInternal$dRIO.pureImpl({
  field: v.field,
  init: iv => v1 => v.init(iv)(defaultInitializer)
}));
const initializeNoInitializerRe = dictInitialize => ({makeImpl: makeWithDefaultInitializer(dictInitialize)({})});
const initializeNoInitialValueR = dictInitialize => (
  {
    makeImpl: p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => Specular$dInternal$dRIO.pureImpl({
      field: v.field,
      init: v1 => v.init($SomeInitialValue({}))
    }))
  }
);
const makeWithInitialValueIniti = dictInitialize => (
  {
    makeWithInitialValueInitializer: p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => Specular$dInternal$dRIO.pureImpl({
      field: v.field,
      init: v1 => v2 => v.init($SomeInitialValue(v2._1))(v2._2)
    }))
  }
);
const makeWithInitialValueIniti1 = dictInitialize => (
  {
    makeWithInitialValueInitializer: p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => Specular$dInternal$dRIO.pureImpl({
      field: v.field,
      init: given_iv => v1 => v.init(given_iv)(v1._2)
    }))
  }
);
const makeEmptyRecordNil = {makeEmptyRecord: v => v1 => () => identity1};
const makeEmptyRecord = dict => dict.makeEmptyRecord;
const makeEmpty_Record = () => dictMakeEmptyRecord => (
  {
    makeEmptyImpl: opts => {
      const $0 = dictMakeEmptyRecord.makeEmptyRecord(Type$dProxy.Proxy)(opts);
      return () => {
        const b = $0();
        return b({});
      };
    }
  }
);
const makeEmptyMaybe = {makeEmptyImpl: v => () => Data$dMaybe.Nothing};
const makeEmptyImpl = dict => dict.makeEmptyImpl;
const makeEmptyRecordCons = dictIsSymbol => dictMakeEmptyRecord => dictMakeEmpty => () => () => (
  {
    makeEmptyRecord: v => opts => {
      const $0 = dictMakeEmpty.makeEmptyImpl({name: Data$dSemigroup.concatArray(opts.name)([dictIsSymbol.reflectSymbol(Type$dProxy.Proxy)])});
      return () => {
        const x = $0();
        const xs = dictMakeEmptyRecord.makeEmptyRecord(Type$dProxy.Proxy)(opts)();
        return x$1 => Record$dBuilder.unsafeInsert(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(x)(xs(x$1));
      };
    }
  }
);
const makeEmptyT2 = dictMakeEmpty => dictMakeEmpty1 => (
  {
    makeEmptyImpl: opts => {
      const $0 = dictMakeEmpty.makeEmptyImpl({...opts, name: Data$dSemigroup.concatArray(opts.name)(["_0"])});
      const $1 = dictMakeEmpty1.makeEmptyImpl({...opts, name: Data$dSemigroup.concatArray(opts.name)(["_1"])});
      return () => {
        const a$p = $0();
        const a$p$1 = $1();
        return Data$dTuple$dT2.$T2(a$p, a$p$1);
      };
    }
  }
);
const makeEmpty = () => dictMonadEffect => dictMakeEmpty => dictMonadEffect.liftEffect(dictMakeEmpty.makeEmptyImpl({name: []}));
const mSelectWriteValue = dict => dict.mSelectWriteValue;
const mSelectTouch = dict => dict.mSelectTouch;
const mSelectReadValue = dict => dict.mSelectReadValue;
const mSelectGetOptions = dict => dict.mSelectGetOptions;
const isMultiSelectFieldWithId = dictIsMultiSelectField => (
  {
    mSelectWriteValue: v => dictIsMultiSelectField.mSelectWriteValue(v._1.field),
    mSelectReadValue: v => dictIsMultiSelectField.mSelectReadValue(v._1.field),
    mSelectGetOptions: v => dictIsMultiSelectField.mSelectGetOptions(v._1.field),
    mSelectTouch: v => dictIsMultiSelectField.mSelectTouch(v._1.field)
  }
);
const liftMaybe = x => Restaumatic$dForm$dFinal.makeFinal((() => {
  const n = Specular$dInternal$dIncremental.constant(x);
  Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
  return n;
})());
const lessThanOrEqual = dictOrd => dictShow => {
  const map = Restaumatic$dForm$dDynamicResult.applyDynamicResult.Functor0().map;
  return a => b => Restaumatic$dForm$dDynamicResult.applyDynamicResult.apply(map(threshold => value => {
    const $0 = [
      Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.lessThanOrEqual),
        {threshold: dictShow.show(threshold)}
      )
    ];
    if (!(dictOrd.compare(value)(threshold).tag === "GT")) { return []; }
    return $0;
  })(a))(b);
};
const lessThan = dictOrd => dictShow => {
  const map = Restaumatic$dForm$dDynamicResult.applyDynamicResult.Functor0().map;
  return a => b => Restaumatic$dForm$dDynamicResult.applyDynamicResult.apply(map(threshold => value => {
    const $0 = [
      Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.lessThan),
        {threshold: dictShow.show(threshold)}
      )
    ];
    if (dictOrd.compare(value)(threshold).tag === "LT") { return []; }
    return $0;
  })(a))(b);
};
const isSelectFieldRefWithOptions = dictIsRefLike => (
  {
    selectWriteValue: v => value => dictIsRefLike.writeRefLike(v.field)($TypedValue("Valid", {value, editValue: Data$dMaybe.Nothing})),
    selectReadValue: v => dictIsRefLike.readRefLike(v.field),
    selectGetOptions: v => v.choices,
    selectTouch: v => dictIsRefLike.touchRefLike(v.field)
  }
);
const isSelectFieldChoiceRef = {
  selectWriteValue: v => a => v.field.currentChoice._2(_old => a),
  selectReadValue: v => Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.Just)(v.field.currentChoice._1),
  selectGetOptions: v => Specular$dFRP$dBase.functorDynamic.map(Data$dFunctor.arrayMap(v.toOption))(v.field.choices),
  selectTouch: v => () => {}
};
const isMultiSelectFieldMultiChoiceRef = {
  mSelectWriteValue: v => a => v.field.currentChoices._2(_old => a),
  mSelectReadValue: v => v.field.currentChoices._1,
  mSelectGetOptions: v => Specular$dFRP$dBase.functorDynamic.map(Data$dFunctor.arrayMap(v.toOption))(v.field.choices),
  mSelectTouch: v => () => {}
};
const initializerFor = dictInitialize => identity;
const hasOptionsSingle = {};
const hasOptionsSet = {};
const hasOptionsSMultiSet = {};
const hasOptionsArray = {};
const hasErrorsOldFormField = {displayedErrors: Specular$dFormField.displayedErrors};
const hasErrorsErrorArray = {displayedErrors: /* #__PURE__ */ unFinalWithDefault([])};
const greaterThanOrEqual = dictOrd => dictShow => {
  const map = Restaumatic$dForm$dDynamicResult.applyDynamicResult.Functor0().map;
  return a => b => Restaumatic$dForm$dDynamicResult.applyDynamicResult.apply(map(threshold => value => {
    const $0 = [
      Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.greaterThanOrEqual),
        {threshold: dictShow.show(threshold)}
      )
    ];
    if (!(dictOrd.compare(value)(threshold).tag === "LT")) { return []; }
    return $0;
  })(a))(b);
};
const greaterThan = dictOrd => dictShow => {
  const map = Restaumatic$dForm$dDynamicResult.applyDynamicResult.Functor0().map;
  return a => b => Restaumatic$dForm$dDynamicResult.applyDynamicResult.apply(map(threshold => value => {
    const $0 = [
      Restaumatic$dI18n._translate(
        Restaumatic$dI18n$dTranslationKeys.unTranslationKey(Restaumatic$dCommon$dTranslations$dKeys.t.form.errors.greaterThan),
        {threshold: dictShow.show(threshold)}
      )
    ];
    if (dictOrd.compare(value)(threshold).tag === "GT") { return []; }
    return $0;
  })(a))(b);
};
const getLabel = dict => dict.getLabel;
const hasLabelMappedField = dictHasLabel => ({getLabel: v => dictHasLabel.getLabel(v.field)});
const hasLabelRefWithOptions = dictHasLabel => ({getLabel: v => dictHasLabel.getLabel(v.field)});
const hasLabelWithId = dictHasLabel => ({getLabel: v => dictHasLabel.getLabel(v._1.field)});
const getFieldId = dict => dict.getFieldId;
const hasFieldIdRefWithOptions = dictHasFieldId => ({getFieldId: v => dictHasFieldId.getFieldId(v.field)});
const hasFieldIdWithOptions = dictHasFieldId => ({getFieldId: v => dictHasFieldId.getFieldId(v.field)});
const getContext = dict => dict.getContext;
const unFinalFromContext = dictHasContext => key => field => Specular$dFRP$dBase.bindDynamic.bind(dictHasContext.getContext(field))(ctx => {
  const $0 = (() => {
    const n = Specular$dInternal$dIncremental.constant(Data$dMaybe.Nothing);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })();
  const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordInt)(key)(ctx);
  if ($1.tag === "Just") { return Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toMaybeLax)($1._1); }
  return $0;
});
const hasContextDelayed = dictHasContext => {
  const getContext1 = dictHasContext.getContext;
  return {getContext: v => Specular$dFRP$dBase.bindDynamic.bind(v)(getContext1)};
};
const hasContextWithId = dictHasContext => ({getContext: v => dictHasContext.getContext(v._1.field)});
const genericTypedValue = {
  to: x => {
    if (x.tag === "Inl") { return $TypedValue("Undefined", x._1); }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return $TypedValue("Invalid", x._1._1); }
      if (x._1.tag === "Inr") { return $TypedValue("Valid", x._1._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Undefined") { return Data$dGeneric$dRep.$Sum("Inl", x._1); }
    if (x.tag === "Invalid") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", x._1)); }
    if (x.tag === "Valid") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", x._1)); }
    $runtime.fail();
  }
};
const genericShow = dictGenericShow => x => dictGenericShow["genericShow'"](genericTypedValue.from(x));
const showTypedValue = dictShow => {
  const $0 = (v, record) => {
    if (record.lastValid.tag === "NoValue") { return " lastValid: noValue "; }
    if (record.lastValid.tag === "SomeValue") { return " lastValid: (SomeValue " + dictShow.show(record.lastValid._1) + ") "; }
    $runtime.fail();
  };
  return {
    show: genericShow((() => {
      const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => ["{" + $0(Type$dProxy.Proxy, v) + "}"]})(UndefinedIsSymbol);
      const $2 = Data$dShow$dGeneric.genericShowConstructor({
        genericShowArgs: v => [
          "{ editValue: " + showMaybe.show(v.editValue) + ", error: " + Restaumatic$dForm$dErrors.showFormErrors.show(v.error) + "," + $0(Type$dProxy.Proxy, v) + "}"
        ]
      })(InvalidIsSymbol);
      const $3 = Data$dShow$dGeneric.genericShowConstructor({
        genericShowArgs: v => ["{ editValue: " + showMaybe.show(v.editValue) + ", value: " + dictShow.show(v.value) + " " + "}"]
      })(ValidIsSymbol);
      return {
        "genericShow'": v => {
          if (v.tag === "Inl") { return $1["genericShow'"](v._1); }
          if (v.tag === "Inr") {
            if (v._1.tag === "Inl") { return $2["genericShow'"](v._1._1); }
            if (v._1.tag === "Inr") { return $3["genericShow'"](v._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
      };
    })())
  };
};
const functorFormDefM = Specular$dInternal$dRIO.functorRIO;
const fromRecord = dict => dict.fromRecord;
const fromChoices = dictFoldable => {
  const $0 = dictFoldable.foldr;
  return dictIsRefLike => field => cs => (
    {
      field,
      choices: Specular$dFRP$dBase.functorDynamic.map(Data$dFunctor.arrayMap(r => Specular$dSelect.$Option("SingleOption", {label: r.name, key: r.id, disabled: false})))(Specular$dFRP$dBase.functorDynamic.map($1 => Data$dArray.fromFoldableImpl(
        $0,
        $1
      ))(cs))
    }
  );
};
const fromArray = dict => dict.fromArray;
const isMultiSelectFieldRefWith = dictContainer => dictIsRefLike => (
  {
    mSelectWriteValue: v => value => dictIsRefLike.writeRefLike(v.field)($TypedValue("Valid", {value: dictContainer.fromArray(value), editValue: Data$dMaybe.Nothing})),
    mSelectReadValue: v => Specular$dFRP$dBase.functorDynamic.map(v$1 => {
      if (v$1.tag === "Nothing") { return []; }
      if (v$1.tag === "Just") { return dictContainer.toArray(v$1._1); }
      $runtime.fail();
    })(dictIsRefLike.readRefLike(v.field)),
    mSelectGetOptions: v => v.choices,
    mSelectTouch: v => () => {}
  }
);
const forceDisplayErrorsKey = /* #__PURE__ */ Data$dVault.newKey();
const forceDisplayErrors = /* #__PURE__ */ Data$dVault.singleton(forceDisplayErrorsKey);
const fieldPathToString = /* #__PURE__ */ Data$dString$dCommon.joinWith(".");
const failFirst = validations_ => value => Restaumatic$dForm$dDynamicResult.andThen(value)(value_ => Restaumatic$dForm$dFinal.makeFinal(Specular$dFRP$dBase.functorDynamic.map((() => {
  const $0 = Data$dFoldable.find(Data$dFoldable.foldableArray)(e => length(e) > 0);
  return x => Data$dMaybe.$Maybe(
    "Just",
    (() => {
      const $1 = $0(x);
      if ($1.tag === "Nothing") { return []; }
      if ($1.tag === "Just") { return $1._1; }
      $runtime.fail();
    })()
  );
})())(sequence(Data$dFunctor.arrayMap((() => {
  const $0 = Specular$dFRP$dBase.functorDynamic.map(v2 => {
    if (v2.tag === "Nothing") { return []; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  });
  return x => $0(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toMaybeLax)(x(Restaumatic$dForm$dDynamicResult.applicativeDynamicResult.pure(value_))));
})())(validations_)))));
const encodeTypedValue = dictEncode => {
  const encodeRecordCons4 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(lastValidIsSymbol)({
    encodeWithOptions: v => x => {
      if (x.tag === "NoValue") { return Foreign$dNullOrUndefined.nullImpl; }
      if (x.tag === "SomeValue") { return dictEncode.encode(x._1); }
      $runtime.fail();
    }
  });
  const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(UndefinedIsSymbol)({
    encodeArgs: opts => v => Data$dList$dTypes.$List(
      "Cons",
      Foreign$dGeneric$dClass.$Arg("RecArg", encodeRecordCons4.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
      Data$dList$dTypes.Nil
    )
  });
  const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(InvalidIsSymbol)((() => {
    const $1 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(encodeRecordCons4)(errorIsSymbol)(encodeWithOptionsOther))(editValueIsSymbol)(encodeWithOptionsOther1);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $1.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })());
  return dictEncodeWithOptions => (
    {
      encode: Foreign$dEncoding.defaultEncode(genericTypedValue)((() => {
        const $2 = Foreign$dGeneric$dClass.genericEncodeConstructor(ValidIsSymbol)((() => {
          const $2 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(valueIsSymbol)(dictEncodeWithOptions))(editValueIsSymbol)(encodeWithOptionsOther1);
          return {
            encodeArgs: opts => v => Data$dList$dTypes.$List(
              "Cons",
              Foreign$dGeneric$dClass.$Arg("RecArg", $2.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
              Data$dList$dTypes.Nil
            )
          };
        })());
        return {
          encodeOpts: v => v1 => {
            if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
            if (v1.tag === "Inr") {
              if (v1._1.tag === "Inl") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
              if (v1._1.tag === "Inr") { return $2.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1._1); }
              $runtime.fail();
            }
            $runtime.fail();
          }
        };
      })())
    }
  );
};
const dynamicFromContextDef = d => key => ctxRef => Specular$dFRP$dBase.bindDynamic.bind(ctxRef._1)(context1 => {
  const $0 = (() => {
    const n = Specular$dInternal$dIncremental.constant(d);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  })();
  const $1 = Data$dMap$dInternal.lookup(Data$dOrd.ordInt)(key)(context1);
  if ($1.tag === "Just") { return $1._1; }
  return $0;
});
const dynamicFromContext = dictHasContext => key => field => Specular$dFRP$dBase.bindDynamic.bind(dictHasContext.getContext(field))(context1 => sequence1((() => {
  const $0 = Data$dMap$dInternal.lookup(Data$dOrd.ordInt)(key)(context1);
  if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", $0._1); }
  return Data$dMaybe.Nothing;
})()));
const dumpStateRecordNil = {
  dumpStateRecord: v => v1 => {
    const n = Specular$dInternal$dIncremental.constant(Foreign$dObject.empty);
    Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
    return n;
  }
};
const dumpStateRecord = dict => dict.dumpStateRecord;
const dumpState_Record = () => dictDumpStateRecord => (
  {
    dumpState: (() => {
      const $0 = dictDumpStateRecord.dumpStateRecord(Type$dProxy.Proxy);
      return x => Specular$dFRP$dBase.functorDynamic.map(encode)($0(x));
    })()
  }
);
const dumpState = dict => dict.dumpState;
const dumpStateRecordCons = dictIsSymbol => dictDumpStateRecord => dictDumpState => () => () => (
  {
    dumpStateRecord: v => f => Specular$dFRP$dBase.applyDynamic.apply(Specular$dFRP$dBase.functorDynamic.map(v1 => v2 => {
      const $0 = dictIsSymbol.reflectSymbol(Type$dProxy.Proxy);
      return Foreign$dObject.mutate($1 => () => {
        $1[$0] = v1;
        return $1;
      })(v2);
    })(dictDumpState.dumpState(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(f))))(dictDumpStateRecord.dumpStateRecord(Type$dProxy.Proxy)(f))
  }
);
const displayedErrors = dict => dict.displayedErrors;
const hasDisplayedErrors = dictHasErrors => {
  const $0 = Specular$dFRP$dBase.functorDynamic.map(x => x.length !== 0);
  return x => $0(dictHasErrors.displayedErrors(x));
};
const hasErrorsDelayed = dictHasErrors => {
  const displayedErrors1 = dictHasErrors.displayedErrors;
  return {displayedErrors: v => Specular$dFRP$dBase.bindDynamic.bind(v)(displayedErrors1)};
};
const hasErrorsMappedField = dictHasErrors => ({displayedErrors: v => dictHasErrors.displayedErrors(v.field)});
const hasErrorsRefWithOptions = dictHasErrors => ({displayedErrors: v => dictHasErrors.displayedErrors(v.field)});
const hasErrorsWithId = dictHasErrors => ({displayedErrors: v => dictHasErrors.displayedErrors(v._1.field)});
const hasErrorsWithOptions = dictHasErrors => ({displayedErrors: v => dictHasErrors.displayedErrors(v.field)});
const displayLocaleKey = /* #__PURE__ */ Data$dVault.newKey();
const displayLocale = /* #__PURE__ */ Data$dVault.singleton(displayLocaleKey);
const defineForm = dictMonadFRP => Specular$dFRP$dHost.liftHost(dictMonadFRP.MonadCleanup1())(dictMonadFRP.MonadEffect0());
const defineForm1 = /* #__PURE__ */ Specular$dFRP$dHost.liftHost(Specular$dFRP$dHost.monadCleanupHost)(Specular$dInternal$dRIO.monadEffectRIO);
const make = dictMonadFRP => {
  const liftHost = Specular$dFRP$dHost.liftHost(dictMonadFRP.MonadCleanup1())(dictMonadFRP.MonadEffect0());
  return dictInitialize => name => f => liftHost(Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(Type$dProxy.Proxy)({name}))(v => {
    const $0 = v.field;
    return Specular$dInternal$dRIO.bindImpl(defineForm1(v.init(NoInitialValue)(f((() => {
      const n = Specular$dInternal$dIncremental.constant($0);
      Specular$dInternal$dIncremental$dNode.annotate(n, "pure");
      return n;
    })()))))(() => Specular$dInternal$dRIO.pureImpl($0));
  }));
};
const define1 = () => f => v => v(f);
const copyState = dict => dict.copyState;
const containerSet = dictOrd => {
  const monoidSet = Data$dSet.monoidSet(dictOrd);
  return {
    fromArray: Data$dFoldable.foldlArray(m => a => Data$dMap$dInternal.insert(dictOrd)(a)()(m))(Data$dMap$dInternal.Leaf),
    toArray: x => toUnfoldable(x),
    Monoid0: () => monoidSet
  };
};
const containerArray = {fromArray: identity, toArray: identity, Monoid0: () => Data$dMonoid.monoidArray};
const bindFormDefM = Specular$dInternal$dRIO.bindRIO;
const makeWithEffectInitializer = dictInitialize => p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => Specular$dInternal$dRIO.pureImpl({
  field: v.field,
  init: iv => v1 => Specular$dInternal$dRIO.bindImpl(v1)(initializer$p => v.init(iv)(initializer$p))
}));
const initializeEffectInitializ = dictInitialize => ({makeImpl: makeWithEffectInitializer(dictInitialize)});
const initializeNoInitialValueT = dictInitialize => dictInitialize1 => (
  {
    makeImpl: v => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(Type$dProxy.Proxy)({...opts, name: Data$dSemigroup.concatArray(opts.name)(["_0"])}))(v1 => {
      const $0 = v1.field;
      return Specular$dInternal$dRIO.bindImpl(dictInitialize1.makeImpl(Type$dProxy.Proxy)({...opts, name: Data$dSemigroup.concatArray(opts.name)(["_1"])}))(v2 => Specular$dInternal$dRIO.pureImpl({
        field: Data$dTuple$dT2.$T2($0, v2.field),
        init: v3 => v4 => {
          const $1 = v4._2;
          return Specular$dInternal$dRIO.bindImpl(v1.init(NoInitialValue)(v4._1))(() => v2.init(NoInitialValue)($1));
        }
      }));
    })
  }
);
const initializeRecordCons = dictIsSymbol => dictInitializeRecord => dictMaybeGetInitialValue => dictMaybeGetInitializer => dictInitialize => () => () => (
  {
    makeRecordImpl: p => v => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(Type$dProxy.Proxy)({
      name: Data$dSemigroup.concatArray(opts.name)([dictIsSymbol.reflectSymbol(Type$dProxy.Proxy)])
    }))(x => Specular$dInternal$dRIO.bindImpl(dictInitializeRecord.makeRecordImpl(p)(Type$dProxy.Proxy)(opts))(xs => Specular$dInternal$dRIO.pureImpl({
      field: x$1 => Record$dBuilder.unsafeInsert(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(x.field)(xs.field(x$1)),
      init: ivs => is => Specular$dInternal$dRIO.bindImpl(x.init(dictMaybeGetInitialValue.maybeGetInitialValue(Type$dProxy.Proxy)(ivs))(dictMaybeGetInitializer.maybeGetInitializer(Type$dProxy.Proxy)(is)))(() => xs.init(ivs)(is))
    })))
  }
);
const initializeSomeInitialValu1 = dictInitialize => dictInitialize1 => (
  {
    makeImpl: v => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(Type$dProxy.Proxy)({...opts, name: Data$dSemigroup.concatArray(opts.name)(["_0"])}))(v1 => {
      const $0 = v1.field;
      return Specular$dInternal$dRIO.bindImpl(dictInitialize1.makeImpl(Type$dProxy.Proxy)({...opts, name: Data$dSemigroup.concatArray(opts.name)(["_1"])}))(v2 => Specular$dInternal$dRIO.pureImpl({
        field: Data$dTuple$dT2.$T2($0, v2.field),
        init: v3 => {
          const $1 = v3._1._1;
          const $2 = v3._1._2;
          return v4 => {
            const $3 = v4._2;
            return Specular$dInternal$dRIO.bindImpl(v1.init($SomeInitialValue($1))(v4._1))(() => v2.init($SomeInitialValue($2))($3));
          };
        }
      }));
    })
  }
);
const asRecordRecord = {fromRecord: identity, toRecord: identity};
const asRecordNewtype = () => ({fromRecord: Unsafe$dCoerce.unsafeCoerce, toRecord: Unsafe$dCoerce.unsafeCoerce});
const applyFormDefM = Specular$dInternal$dRIO.applyRIO;
const semigroupFormDefM = dictSemigroup => (
  {
    append: (() => {
      const $0 = dictSemigroup.append;
      return a => b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl($0)(a))(b);
    })()
  }
);
const applicativeFormDefM = Specular$dInternal$dRIO.applicativeRIO;
const traverse_ = /* #__PURE__ */ Data$dFoldable.traverse_(Specular$dInternal$dRIO.applicativeRIO)(Data$dFoldable.foldableArray);
const define = () => f => traverse_(v => v(f));
const monoidFormDefM = dictMonoid => {
  const semigroupFormDefM1 = {
    append: (() => {
      const $0 = dictMonoid.Semigroup0().append;
      return a => b => Specular$dInternal$dRIO.applyImpl(Specular$dInternal$dRIO.mapImpl($0)(a))(b);
    })()
  };
  return {mempty: Specular$dInternal$dRIO.pureImpl(dictMonoid.mempty), Semigroup0: () => semigroupFormDefM1};
};
const initializeRecordNil = {makeRecordImpl: v => v1 => v2 => Specular$dInternal$dRIO.pureImpl({field: identity1, init: v3 => v4 => Specular$dInternal$dRIO.pureImpl()})};
const annotatedFinal = name => x => Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.liftV)((() => {
  const $0 = Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toVLax)(x);
  return (() => {
    Specular$dInternal$dIncremental$dNode.annotate($0, name);
    return $0;
  })();
})());
const annotateFinal = dictMonadEffect => x => Specular$dFRP$dBase.annotate(dictMonadEffect)(Specular$dFRP$dBase.functorDynamic.map(Restaumatic$dForm$dResult.toMaybeLax)(x));
const afterInitialized = eff => Specular$dInternal$dRIO.bindImpl(() => ({value: () => {}}))(unsubRef => Specular$dInternal$dRIO.bindImpl(Specular$dFRP$dHost.monadCleanupHost.onCleanup(() => {
  const unsub = unsubRef.value;
  unsubRef.value = () => {};
  return unsub();
}))(() => Specular$dExtra$dAsync.nextMicrotask((() => {
  const $0 = Specular$dFRP$dHost.runHost(eff);
  return () => {
    const v = $0();
    return unsubRef.value = v._2;
  };
})())));
const addMetadataRecord = dict => dict.addMetadataRecord;
const addMetadataRecordRecordRe = () => () => () => () => dictAddMetadataRecord => ({addMetadata: m => rec => dictAddMetadataRecord.addMetadataRecord(Type$dProxy.Proxy)(m)(rec)});
const addMetadata = dict => dict.addMetadata;
const makeWithMetadataInitializer = dictInitialize => dictAddMetadata => p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => Specular$dInternal$dRIO.pureImpl({
  field: v.field,
  init: iv => v1 => v.init(iv)(dictAddMetadata.addMetadata(v1._1)(v1._2))
}));
const initializeMetadataInitial = dictAddMetadata => dictInitialize => ({makeImpl: makeWithMetadataInitializer(dictInitialize)(dictAddMetadata)});
const addMetadataContextInitial = dictAddMetadata => ({addMetadata: m => v => $ContextInitializer(v._1, dictAddMetadata.addMetadata(m)(v._2))});
const addMetadataEffectInitiali = dictAddMetadata => ({addMetadata: m => v => Specular$dInternal$dRIO.mapImpl(dictAddMetadata.addMetadata(m))(v)});
const addMetadataFunctionFuncti = dictAddMetadata => ({addMetadata: m => f => a => dictAddMetadata.addMetadata(m)(f(a))});
const addMetadataInitialValueIn = dictAddMetadata => ({addMetadata: m => v => $InitialValueInitializer(v._1, dictAddMetadata.addMetadata(m)(v._2))});
const addMetadataRecordCons = dictIsSymbol => dictAddMetadataRecord => dictAddMetadata => () => () => () => () => () => (
  {
    addMetadataRecord: v => meta => is => Record$dUnsafe.unsafeSet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(dictAddMetadata.addMetadata(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(meta))(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(is)))(dictAddMetadataRecord.addMetadataRecord(Type$dProxy.Proxy)(meta)(Record$dUnsafe.unsafeDelete(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(is)))
  }
);
const addContextRecordNil = {addContextRecord: v => v1 => v2 => () => {}};
const addContextRecord = dict => dict.addContextRecord;
const addContext_Record = () => dictAddContextRecord => ({addContext: dictAddContextRecord.addContextRecord(Type$dProxy.Proxy)});
const addContextMaybe = {addContext: v => v1 => () => {}};
const addContext = dict => dict.addContext;
const addContextRecordCons = dictIsSymbol => dictAddContextRecord => dictAddContext => () => () => (
  {
    addContextRecord: v => ctx => f => {
      const $0 = dictAddContext.addContext(ctx)(Record$dUnsafe.unsafeGet(dictIsSymbol.reflectSymbol(Type$dProxy.Proxy))(f));
      return () => {
        $0();
        return dictAddContextRecord.addContextRecord(Type$dProxy.Proxy)(ctx)(f)();
      };
    }
  }
);
const context = dictAddContext => ctx => f => dictAddContext.addContext(ctx)(f);
const makeWithContextInitializer = dictInitialize => dictAddContext => p => opts => Specular$dInternal$dRIO.bindImpl(dictInitialize.makeImpl(p)(opts))(v => {
  const $0 = v.field;
  return Specular$dInternal$dRIO.pureImpl({
    field: $0,
    init: iv => v1 => {
      const $1 = v1._2;
      return Specular$dInternal$dRIO.bindImpl(dictAddContext.addContext(v1._1)($0))(() => v.init(iv)($1));
    }
  });
});
const initializeContextInitiali = dictAddContext => dictInitialize => ({makeImpl: makeWithContextInitializer(dictInitialize)(dictAddContext)});
const addContextT2 = dictAddContext => dictAddContext1 => (
  {
    addContext: ctx => v => {
      const $0 = v._2;
      const $1 = dictAddContext.addContext(ctx)(v._1);
      return () => {
        $1();
        return dictAddContext1.addContext(ctx)($0)();
      };
    }
  }
);
export {
  $ContextInitializer,
  $InitialValueInitializer,
  $MetadataInitializer,
  $NoInitialValue,
  $NoInitializer,
  $SomeInitialValue,
  $TypedValue,
  $WithId,
  Attribute,
  ContextInitializer,
  EffectInitializer,
  FormDefM,
  InitialValueInitializer,
  Invalid,
  InvalidIsSymbol,
  MappedField,
  Metadata,
  MetadataInitializer,
  NoInitialValue,
  NoInitializer,
  RefWithOptions,
  SomeInitialValue,
  Undefined,
  UndefinedIsSymbol,
  Valid,
  ValidIsSymbol,
  WithId,
  WithOptions,
  addContext,
  addContextDynamic,
  addContextEffect,
  addContextFormField,
  addContextMaybe,
  addContextRecord,
  addContextRecordCons,
  addContextRecordNil,
  addContextRef,
  addContextT2,
  addContext_Record,
  addMetadata,
  addMetadataContextInitial,
  addMetadataDynamicDynamic,
  addMetadataEffectEffect,
  addMetadataEffectInitiali,
  addMetadataFinalStringNoI,
  addMetadataFinalStringRec,
  addMetadataFunctionFuncti,
  addMetadataInitialValueIn,
  addMetadataMetadataNoInit,
  addMetadataMetadataRecord,
  addMetadataRecord,
  addMetadataRecordCons,
  addMetadataRecordNil,
  addMetadataRecordRecordRe,
  afterInitialized,
  annotateFinal,
  annotatedFinal,
  applicativeFormDefM,
  applyFormDefM,
  asRecordNewtype,
  asRecordRecord,
  bindFormDefM,
  containerArray,
  containerSet,
  context,
  copyState,
  define,
  define1,
  defineForm,
  defineForm1,
  displayLocale,
  displayLocaleKey,
  displayedErrors,
  dumpState,
  dumpStateRecord,
  dumpStateRecordCons,
  dumpStateRecordNil,
  dumpState_Record,
  dynamicFromContext,
  dynamicFromContextDef,
  editValueIsSymbol,
  encode,
  encodeTypedValue,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  errorIsSymbol,
  failFirst,
  fieldPathToString,
  forceDisplayErrors,
  forceDisplayErrorsKey,
  fromArray,
  fromChoices,
  fromRecord,
  functorFormDefM,
  genericShow,
  genericTypedValue,
  getContext,
  getFieldId,
  getLabel,
  greaterThan,
  greaterThanOrEqual,
  hasContextContext,
  hasContextDelayed,
  hasContextRefContext,
  hasContextWithId,
  hasDisplayedErrors,
  hasErrorsChoiceRef,
  hasErrorsDelayed,
  hasErrorsErrorArray,
  hasErrorsMappedField,
  hasErrorsOldFormField,
  hasErrorsRef,
  hasErrorsRefWithOptions,
  hasErrorsWithId,
  hasErrorsWithOptions,
  hasFieldIdChoiceRef,
  hasFieldIdEffect,
  hasFieldIdFormField,
  hasFieldIdFunctionEffect,
  hasFieldIdRef,
  hasFieldIdRefWithOptions,
  hasFieldIdString,
  hasFieldIdWithId,
  hasFieldIdWithOptions,
  hasLabelFormField,
  hasLabelMappedField,
  hasLabelRef,
  hasLabelRefWithOptions,
  hasLabelWithId,
  hasOptionsArray,
  hasOptionsSMultiSet,
  hasOptionsSet,
  hasOptionsSingle,
  identity,
  identity1,
  initializeContextInitiali,
  initializeEffectInitializ,
  initializeInitialValueIni,
  initializeMetadataInitial,
  initializeNoInitialValueR,
  initializeNoInitialValueT,
  initializeNoInitializerRe,
  initializeRecordCons,
  initializeRecordNil,
  initializeSomeInitialValu,
  initializeSomeInitialValu1,
  initializerFor,
  isMultiSelectFieldMultiChoiceRef,
  isMultiSelectFieldRefWith,
  isMultiSelectFieldWithId,
  isRefLikeFormField,
  isRefLikeRef,
  isRefLikeWithId,
  isSelectFieldChoiceRef,
  isSelectFieldRefWithOptions,
  isSelectFieldWithId,
  isTextFieldFormFieldStrin,
  isTextFieldRefString,
  isTextFieldWithId,
  lastValidIsSymbol,
  length,
  lessThan,
  lessThanOrEqual,
  liftMaybe,
  mSelectGetOptions,
  mSelectReadValue,
  mSelectTouch,
  mSelectWriteValue,
  make,
  makeEmpty,
  makeEmptyImpl,
  makeEmptyMaybe,
  makeEmptyRecord,
  makeEmptyRecordCons,
  makeEmptyRecordNil,
  makeEmptyT2,
  makeEmpty_Record,
  makeImpl,
  makeRecordImpl,
  makeWithContextInitializer,
  makeWithDefaultInitializer,
  makeWithEffectInitializer,
  makeWithInitialValueIniti,
  makeWithInitialValueIniti1,
  makeWithInitialValueInitializer,
  makeWithMetadataInitializer,
  mapDynamicFinal,
  mapMaybeFinal,
  mapMaybeFinalInternal,
  mapMaybeFinalUserVisible,
  mapVFinal,
  maybeContainerToArray,
  maybeGetInitialValue,
  maybeGetInitialValue$p,
  maybeGetInitialValue$pFals,
  maybeGetInitialValue$pTrue,
  maybeGetInitialValue1,
  maybeGetInitializer,
  maybeGetInitializer$p,
  maybeGetInitializer$pFalse,
  maybeGetInitializer$pTrue,
  maybeGetInitializer1,
  measure,
  merge,
  mergeChoiceRef,
  mergeDelayed,
  mergeInputRequired,
  mergeRecord,
  mergeRecordCons,
  mergeRecordNil,
  mergeRef,
  mergeT2T2,
  mergeUnit,
  merge_Record,
  monadCleanupFormDefM,
  monadEffectFormDefM,
  monadFormDefM,
  monoidFormDefM,
  nonEmpty,
  optionForEq,
  ordMaybe,
  readRefLike,
  requiredError,
  selectGetOptions,
  selectInput,
  selectReadValue,
  selectTouch,
  selectWriteValue,
  semigroupFormDefM,
  sequence,
  sequence1,
  shorterThan,
  showMaybe,
  showTypedValue,
  singleOption,
  tagErrors,
  textInput,
  toArray,
  toRecord,
  toUnfoldable,
  touchRefLike,
  traverse,
  traverse_,
  unFinalFromContext,
  unFinalFromContextDef,
  unFinalWithDefault,
  validateJust,
  validateJustIf,
  validateTrue,
  validateWhenJust,
  validateWhenValueJust,
  valueIsSymbol,
  withContext,
  withEffect,
  withFinal_,
  withId,
  withInitialValue,
  withMetadata,
  withNothing,
  withOptions,
  write,
  write1,
  writeRef,
  writeRefLike
};
